export default __webpack_public_path__ + "static/media/Thirteen.c966bb8e.svg";